window.$ = window.jQuery = require('jquery');
require('vgnav/dist/js/vgnav');
require('vgformsender/dist/js/vgformsender.min');
require('vgscrollto/dist/js/vegascrollto.min');
require('popper.js/dist/popper.min');
require('bootstrap/dist/js/bootstrap.min');
require('jquery-nice-select/js/jquery.nice-select.min');
require('@fancyapps/fancybox/dist/jquery.fancybox');
require('zurb-twentytwenty/js/jquery.event.move');
require('zurb-twentytwenty/js/jquery.twentytwenty');
require('inputmask/dist/inputmask');

window.VGNav = require('vgnav/dist/js/vgnav');
window.Select2 = require('select2/dist/js/select2');
require('select2/dist/js/i18n/ru');

require('../../vendor/dropdown/jquery.vegasDropdown');
require('../../vendor/modules/bg');
require('../../vendor/modules/carousel');
require('../../vendor/modules/modal');
require('../../vendor/modules/mask');
require('../../vendor/modules/select2');

require('./functions');

require('./modules/vegas');
require('./modules/ym');
require('./modules/input-counter');
require('./modules/shop/shop');

// [[vegas]]
require('./custom');
